export type SeriesDetailPropType = {
    match: {
        params: any;
        isExact: boolean;
        path: string;
        url: string;
    };
};

export const QUERY_PARAM_EPISODE = 'episode';
export const QUERY_PARAM_EVENT = 'event';
